// extracted by mini-css-extract-plugin
module.exports = {"actionIcon":"src-components-AvatarTimer-styles-module__actionIcon--3A17K"};